import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import invariant from 'invariant';
import IconButton from '@material-ui/core/IconButton';
import IconLeft from '@material-ui/icons/ChevronLeft';
import IconRight from '@material-ui/icons/ChevronRight';
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({}, theme.breakpoints.down('sm'), {
      padding: theme.spacing(0.5)
    }),
    disabled: {}
  };
}, {
  name: 'SxComProductImgListArrow'
});

var _ref2 = /*#__PURE__*/React.createElement(IconLeft, null);

var _ref3 = /*#__PURE__*/React.createElement(IconRight, null);

function ProductImgListArrow(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      disabled = _ref.disabled,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "disabled", "left", "right"]);

  var classes = useStyles({
    classes: pClasses
  });
  invariant(left || right, "ProductCarouselArrow require 'left' or 'right' props to be `true`");
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    className: clsx(classes.root, className, disabled && classes.disabled),
    disabled: disabled
  }, pickHTMLProps(rest)), left ? _ref2 : _ref3);
}

ProductImgListArrow.propTypes = {
  classes: PropTypes.shape({
    disabled: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  left: PropTypes.bool,
  onClick: PropTypes.func,
  right: PropTypes.bool
};
ProductImgListArrow.defaultProps = {
  classes: undefined,
  className: undefined,
  disabled: false,
  left: false,
  onClick: undefined,
  right: false
};
export default ProductImgListArrow;